<template>
  <se-message-bubble
      v-if="props.message"
      :time="getTime(props.message.created_at)"
      :position="props.position"
      :status="!props.historyMode ? props.message.is_unread ? 'Sent' : 'Read' : ''"
      :class="{'system' : props.isSystemMessage}"
  >
    <p v-if="isSystemMessage" v-html="props.message"/>
    <div v-else-if="props.message.is_image" @click="openImgModal(apiUrl + props.message.body)">
      <img :src="apiUrl + props.message.body" :alt="props.message.body" class="image-preview">
    </div>
    <p v-else-if="props.message.type === 'text' || props.message.body">
      {{ props.message.body }}
      <span class="inline-block h-[1px]" :class="props.position === 'right' ? 'w-[100px]' : 'w-[60px]'" />
    </p>
    <p v-else>[{{ props.message.type }}] Unsupported message type...</p>
  </se-message-bubble>
</template>

<script setup lang="ts">
import { withDefaults } from 'vue';
import config from "@/config";
import SeMessageBubble from "@/src/shared/ui-kit/message-bubble/MessageBubble.vue";
import useDateFormatter from "@/src/composables/useDateFormatter";

const emits = defineEmits(['onImgModalOpen']);

const props = withDefaults(defineProps<{
  message: any, // TODO: add message type
  isSystemMessage?: boolean,
  position: 'left' | 'right',
  historyMode?: boolean,
}>(), {
  position: 'left',
  isSystemMessage: false,
  historyMode: false,
});

const apiUrl = config.api.url

const getTime = (time: any) => time && useDateFormatter().formatDate(time, "HH:mm")

const openImgModal = (url) => {
  emits('onImgModalOpen', url);
}
</script>
<script lang="ts">
export default {
  name: 'SeSessionMessageBubble',
};
</script>

<style lang="scss">
</style>
